import { render, staticRenderFns } from "./slideGame.vue?vue&type=template&id=6d9dfad2&scoped=true"
import script from "./slideGame.vue?vue&type=script&lang=js"
export * from "./slideGame.vue?vue&type=script&lang=js"
import style0 from "./slideGame.vue?vue&type=style&index=0&id=6d9dfad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9dfad2",
  null
  
)

export default component.exports